"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  mobileheight: 50,
  tabletheight: 100,
  desktopheight: 100
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;